import { takeLatest, takeEvery } from 'redux-saga';
import { apply, call, put } from 'redux-saga/effects';
import { delay } from '../../common/utils.jsx';
import { api } from '../../common/api/api.js';
import { APP_VERSION } from '../app.config.jsx';
import {
    SET_FIELD_VALUE, RESET_FIELD_VALUE, COMPLETE_QUESTIONNAIRE, PEDIGREE_GENERATED,
    SERVER_SAVED, SERVER_ERROR_ON_SAVE, SERVER_ERROR_ON_COMPLETE
} from '../app.reducer.jsx';
import { UPDATE_PERSON_FIELD, UPDATE_PERSON_RELATION } from './family.cancer.history/reducer.jsx';
import { store } from '../app.store.jsx';
import { MANUAL_CANCEL } from '../constants.jsx';

const TOKEN_INPUT = document.getElementById('questionnaire-token');
const TOKEN = TOKEN_INPUT.value;
const questionnaireService = api.service('questionnaire');
const method = questionnaireService.put;
const FIELD_UPDATE_DEBOUNCE = 3000;

export function getFields() {
    const state = store.getState();
    const fields = state.fields.toJS();
    fields.APP_VERSION = APP_VERSION;
    return fields;
}

export function* sendFieldsDataToServer() {
    try {
        yield call(delay, FIELD_UPDATE_DEBOUNCE);
        const fields = getFields();
        const questionnaireData = JSON.stringify({ answers: { fields } });
        if (!fields.finished) {
            yield apply(questionnaireService, method, [{ data: questionnaireData, contentType: 'application/json', processData: false }, TOKEN ]);
            yield put({ type: SERVER_SAVED });
        }
    } catch (err) {
        if ('MANUAL_CANCEL' !== err.type) {
            console.error(err);
            yield put({ type: SERVER_ERROR_ON_SAVE, details: err });
        }
    }
}

export function* sendCompletedQuestionnaireToServer() {
    try {
        const fields = getFields();
        const questionnaireData = JSON.stringify({ answers: { fields } });
        yield apply(questionnaireService, method, [{ data: questionnaireData, contentType: 'application/json', processData: false }, TOKEN ]);
        yield put({ type: PEDIGREE_GENERATED });
    } catch (err) {
        if (MANUAL_CANCEL !== err.type) {
            console.error(err);
            yield put({ type: SERVER_ERROR_ON_COMPLETE, details: err });
        }
    }
}

export default function* fieldsSaga() {
    yield [
        takeEvery(COMPLETE_QUESTIONNAIRE, sendCompletedQuestionnaireToServer),
        takeLatest([ SET_FIELD_VALUE, RESET_FIELD_VALUE, UPDATE_PERSON_RELATION, UPDATE_PERSON_FIELD ], sendFieldsDataToServer)
    ];
}
